import React, { useState } from "react";
import FilterShell from "./FilterShell";

const defaultState = {
  status: "",
  startDate: "",
  endDate: "",
};

const STATUS_OPTIONS = [
  "payment-pending",
  "request-pending",
  "rejected",
  "accepted",
  "completed",
  "cancelled",
];

const UserBookingsFilters = ({ onApply, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className="col-md-3">
        <label className="form-label">Status</label>
        <select
          name="status"
          className="form-control"
          value={data.status}
          onChange={onChange}
        >
          <option value="">All</option>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s.replace(/-/g, " ")}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-3">
        <label className="form-label">From</label>
        <input
          type="date"
          name="startDate"
          className="form-control"
          value={data.startDate}
          onChange={onChange}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">To</label>
        <input
          type="date"
          name="endDate"
          className="form-control"
          value={data.endDate}
          onChange={onChange}
        />
      </div>
    </FilterShell>
  );
};

export default UserBookingsFilters;
